import { ObjectTools } from '../../../tools/object-tools';

export class SolTabState {
  private constructor(
    public readonly id: string,
    public readonly visible: boolean,
  ) {}

  public static of(): SolTabState {
    return new SolTabState('', false);
  }

  public withId(id: string): SolTabState {
    return this.copy({ id });
  }

  public withVisible(visible: boolean): SolTabState {
    return this.copy({ visible });
  }

  private copy(props: Partial<SolTabState>): SolTabState {
    return ObjectTools.copy<SolTabState>(this, props);
  }
}
